import { render } from "./DownedBirdForm.vue?vue&type=template&id=b472f6f2&scoped=true"
import script from "./DownedBirdForm.vue?vue&type=script&lang=js"
export * from "./DownedBirdForm.vue?vue&type=script&lang=js"

import "./DownedBirdForm.vue?vue&type=style&index=0&id=b472f6f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b472f6f2"]])

export default __exports__